/**
 * L5: replica age (03 CSO caveat: the phone copy can fall behind the Mac, so its age is always
 * visible and an old copy says so plainly).
 */
export type StalenessLevel = "fresh" | "aging" | "stale";

export interface ReplicaAge {
  level: StalenessLevel;
  /** e.g. "Updated 2 hours ago". */
  label: string;
  ageMs: number;
}

const MIN = 60_000;
const HOUR = 60 * MIN;
const DAY = 24 * HOUR;

/** Under 6 h is fresh, under 24 h is aging, and 24 h or more is stale. */
export const AGING_AFTER_MS = 6 * HOUR;
export const STALE_AFTER_MS = DAY;

export function replicaAge(asOf: string, now: number): ReplicaAge {
  const t = Date.parse(asOf);
  const ageMs = Number.isNaN(t) ? Number.POSITIVE_INFINITY : Math.max(0, now - t);
  const level: StalenessLevel = ageMs >= STALE_AFTER_MS ? "stale" : ageMs >= AGING_AFTER_MS ? "aging" : "fresh";
  return { level, ageMs, label: Number.isFinite(ageMs) ? `Updated ${ago(ageMs)}` : "Update time unknown" };
}

export function ago(ms: number): string {
  if (ms < MIN) return "just now";
  if (ms < HOUR) return plural(Math.floor(ms / MIN), "minute");
  if (ms < DAY) return plural(Math.floor(ms / HOUR), "hour");
  return plural(Math.floor(ms / DAY), "day");
}

const plural = (n: number, unit: string) => `${n} ${unit}${n === 1 ? "" : "s"} ago`;
